import { useState } from "react";
import PasswordInput from "../../shared/PasswordInput";
import Button from "../../shared/Button";
import { useMutation } from "react-query";
import { setNewAuthPassword } from "../../sdk/auth/auth";
import { useError } from "../../context/ErrorProvider";
import useAuth from "../../hooks/useAuth";
import SetPasswordSuccess from "../../components/auth/SetPasswordSuccess";

const SetPassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const { showError } = useError();
  const { auth } = useAuth();
  const [openPasswordSuccess, setOpenPasswordSuccess] = useState(false);

  const togglePasswordSuccess = () => {
    setOpenPasswordSuccess(true);
  };

  const closePasswordSuccess = () => {
    setOpenPasswordSuccess(false);
  };

  const handleSetPassword = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const errorMessage = Object.values(validationErrors).join("\n");
      showError(errorMessage);
      return;
    }
    setErrors({});
    setNewPasswordMutate({
      id: auth?.user?.id,
      currentPassword: oldPassword,
      newPassword,
    });
  };

  const { mutate: setNewPasswordMutate, isLoading: isLoadingSetPassword } =
    useMutation({
      mutationKey: ["setNewPassword"],
      mutationFn: ({ id, currentPassword, newPassword }) =>
        setNewAuthPassword(id, currentPassword, newPassword),
      onSuccess: () => {
        togglePasswordSuccess();
      },
      onError: (error) => {
        showError(error?.response?.data?.message || error.message);
      },
    });

  const validate = () => {
    const newErrors = {};
    if (!oldPassword) newErrors.oldPassword = "Current password is required.";
    if (!newPassword) {
      newErrors.newPassword = "New password is required.";
    } else if (!/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(newPassword)) {
      newErrors.newPassword =
        "Password must include a letter, number, special character and be at least 8 characters.";
    }
    if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    return newErrors;
  };
  return (
    <>
      {openPasswordSuccess && (
        <SetPasswordSuccess closeSetPasswordSuccess={closePasswordSuccess} />
      )}
      <div className="h-full w-full flex flex-col pb-[100px] justify-end">
        <p className="text-[#222222] font-semibold text-[20px]">
          Welcome {auth?.user?.firstname ?? "Guest"}! Create a New Password
        </p>
        <p className="text-[#5C5C5C] font-normal text-[14px]">
          Create your account password by filling in the fields below
        </p>
        <form className="w-[80%]" onSubmit={handleSetPassword}>
          <div className="flex flex-col my-[20px]">
            <label
              className="font-medium text-[13px] text-[#000000]"
              htmlFor="password"
            >
              Current Password
            </label>
            <PasswordInput
              placeholder="Enter your password"
              name="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
            {errors.oldPassword && (
              <p className="text-[#000000] text-[12px]">{errors.oldPassword}</p>
            )}
          </div>
          <div className="flex flex-col my-[20px]">
            <label
              className="font-medium text-[13px] text-[#000000]"
              htmlFor="password"
            >
              New Password
            </label>
            <PasswordInput
              placeholder="Enter your password"
              name="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            {errors.newPassword ? (
              <p className="text-[#000000] text-[13px]">{errors.newPassword}</p>
            ) : (
              <p className="text-[#5C5C5C] text-[13px]">
                Password must contain a letter, a number, a special character,
                and be at least 8 characters long.
              </p>
            )}
          </div>
          <div className="flex flex-col my-[20px]">
            <label
              className="font-medium text-[13px] text-[#000000]"
              htmlFor="password"
            >
              Confirm Password
            </label>
            <PasswordInput
              placeholder="Enter your password"
              name="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {errors.confirmPassword && (
              <p className="text-[#000000] text-[13px]">
                {errors.confirmPassword}
              </p>
            )}
          </div>
          <div className="w-full mt-[50px]">
            <Button
              label="Update Password"
              disabled={isLoadingSetPassword}
              isLoading={isLoadingSetPassword}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default SetPassword;
